import React from 'react'

export default function Resenias() {
    return (
        <section className="resenas">
            <div className="resenas_title">
                <h3>Reseñas</h3>
                <button> + añadir reseñas</button>
            </div>
            <article>
                <p>No hay reseñas actualmente</p>
            </article>
        </section>
    )
}
